import request from "@/utils/request";

//首页文章查询
export const getHomeAtrticle = () => {
  return request({
    url: "/index/article/getHomeAtrticle",
    method: "post",
  });
};
//首页文章分页
export const getColumnList = (params) => {
  return request({
    url: "/index/article/getPage",
    method: "post",
    data: params,
  });
};
//首页文章详情
export const getArticleDetail = (id) => {
  return request({
    url: `/index/article/getInfor/${id}`,
    method: "post",
  });
};
//在研课题
export const getResearchTopicsList = (params) => {
  return request({
    url: "/index/declare/researchTopics",
    method: "post",
    data: params,
  });
};
//项目列表
export const getProjectList = (params) => {
  return request({
    url: "/index/project/list",
    method: "post",
    data: params,
  });
};

//项目列表
export const getProjectList1 = (params) => {
  return request({
    url: "/index/project/list1",
    method: "post",
    data: params,
  });
};

//项目列表详情
export const getProjectListDetail = (id) => {
  return request({
    url: "/index/project/list/"+id,
    method: "get",
  });
};


//搜索文章
export const searchArticle = (data) => {
  return request({
    url: "/index/article/searchArticle",
    method: "post",
    data,
  });
};

//科研资源列表
export const getResourcesList = (data) => {
  return request({
    url: "/index/resources/list",
    method: "post",
    data,
  });
};
